import React, { useCallback } from 'react';
import { createBed } from '../../actions/beds';

const fieldStyle = {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
    borderBottom: '1px solid #f0f0f0',
};

const labelStyle = {
    color: '#888',
    fontSize: 13,
    marginBottom: 4,
};

const inputStyle = {
    border: '1px solid #e0e0e0',
    borderRadius: 6,
    padding: '7px 10px',
    fontSize: 14,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
};

const selectStyle = {
    ...inputStyle,
    backgroundColor: '#fff',
    appearance: 'auto',
};

const CreateBedForm = () => {
    const validateForm = useCallback((event) => {
        event.preventDefault();
        const form = event.target;
        createBed(form).then((result) => {
            if (result) {
                setTimeout(function () {
                    window.location.reload(false);
                }.bind(this), 1000);
            }
        });
    }, []);

    return (
        <div style={{ padding: '28px 20px 20px' }}>

            {/* En-tête */}
            <div style={{ marginBottom: 16 }}>
                <span style={{ fontSize: 22, fontWeight: 'bold' }}>Créer un lit</span>
            </div>

            <hr style={{ margin: '0 0 4px' }} />

            <form onSubmit={validateForm}>

                {/* Numéro */}
                <div style={fieldStyle}>
                    <label htmlFor="number" style={labelStyle}>Numéro</label>
                    <input id="number" name="number" type="number" style={inputStyle} />
                </div>

                {/* N° de série */}
                <div style={fieldStyle}>
                    <label htmlFor="serialNumber" style={labelStyle}>Numéro de série</label>
                    <input id="serialNumber" name="serialNumber" type="text" style={inputStyle} />
                </div>

                {/* Client */}
                <div style={fieldStyle}>
                    <label htmlFor="client" style={labelStyle}>Client</label>
                    <input id="client" name="client" type="text" style={inputStyle} />
                </div>

                {/* Pharmacie */}
                <div style={fieldStyle}>
                    <label htmlFor="pharmacy" style={labelStyle}>Pharmacie</label>
                    <select name="pharmacy" id="pharmacy" style={selectStyle}>
                        <option value="Cremers">Cremers</option>
                        <option value="Violaines">Violaines</option>
                        <option value="Mont à Camp">Mont à Camp</option>
                        <option value="Grand Stade">Grand Stade</option>
                    </select>
                </div>

                {/* Modèle */}
                <div style={fieldStyle}>
                    <label htmlFor="model" style={labelStyle}>Modèle</label>
                    <select name="model" id="model" style={selectStyle}>
                        <option value="Euro 1000">Euro 1000</option>
                        <option value="Euro 1000 Boiserie">Euro 1000 Boiserie</option>
                        <option value="Euro 1002">Euro 1002</option>
                        <option value="Euro 1600">Euro 1600</option>
                        <option value="Euro 3000">Euro 3000</option>
                        <option value="Sotec">Sotec</option>
                        <option value="Sotec (Gris Clair)">Sotec (Gris Clair)</option>
                        <option value="Autre">Autre</option>
                    </select>
                </div>

                {/* Moteurs */}
                <div style={fieldStyle}>
                    <label htmlFor="motors" style={labelStyle}>Nombre de moteurs</label>
                    <input id="motors" name="motors" type="number" style={inputStyle} inputMode="numeric" />
                </div>

                {/* Année */}
                <div style={fieldStyle}>
                    <label htmlFor="year" style={labelStyle}>Année</label>
                    <input id="year" name="year" type="number" style={inputStyle} inputMode="numeric" />
                </div>

                {/* En location */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
                    <span style={{ color: '#888', fontSize: 13 }}>En location</span>
                    <input id="isRent" name="isRent" type="checkbox" style={{ width: 18, height: 18, cursor: 'pointer' }} />
                </div>

                {/* Bouton */}
                <button
                    type="submit"
                    className="btn btn-primary w-100"
                    style={{ borderRadius: 8, marginTop: 20, display: 'block', textAlign: 'center' }}
                >
                    Créer le lit
                </button>

            </form>
        </div>
    );
};

export { CreateBedForm };
